export default {
  // 標籤頁
  transactionSummary: "交易匯總",
  transactionCounterpart: "交易對手",
  transactionDetails: "交易詳情",

  // 搜索表單佔位符
  dataSourcePlaceholder: "數據來源",
  directionPlaceholder: "交易方向",
  currencyPlaceholder: "幣種",
  targetAddressPlaceholder: "請輸入交易對手地址",
  minAmountPlaceholder: "最小金額",
  maxAmountPlaceholder: "最大金額",
  startDatePlaceholder: "開始日期",
  endDatePlaceholder: "結束日期",

  // 按鈕
  resetBtn: "重置",
  searchBtn: "查詢",
  downloadBtn: "下載數據明細",

  // 數據來源選項
  sourceTypeChain: "鏈上數據",
  sourceTypeInternal: "平台內部",

  // 交易方向選項
  directionInflow: "充幣",
  directionOutflow: "提幣",

  // 表格列標題
  columnDirection: "交易方向",
  columnCounterpart: "交易對手",
  columnCurrency: "幣種",
  columnQuantity: "交易數量",
  columnTime: "交易時間",
  columnHash: "交易哈希",

  // 提示文本
  maxAmountWarning: "最大金額需≥最小金額",
  totalDataText: "共計",
  dataCountText: "條數據",
  loadingText: "拼命加載中",

  // 空狀態
  emptyText: "當前調證文件中未解析到充提交易數據",

  // 下載
  downloadFileName: "數據明細",

  // 消息提示
  copySuccess: "複製成功",

  // Summary 頁面特有
  selectTypePlaceholder: "請選擇",
  selectTypeTotalQuantity: "總數量",
  selectTypeTotalCount: "交易次數",
  minQuantityPlaceholder: "最小數量",
  maxQuantityPlaceholder: "最大數量",
  maxQuantityWarning: "最大數量需≥最小數量",
  columnTotalCount: "交易次數",
  columnTotalQuantity: "交易總數量",
};
